import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

type ThemeChannel = 'estore' | 'mobile_app'

export const UI_CHANNEL_TO_API: Record<'estore' | 'mobile', ThemeChannel> = {
  estore: 'estore',
  mobile: 'mobile_app',
}

class DesignAPIs {
  static async getThemesList() {
    return (await $http.get('/themes')).data
  }

  static async getTheme(branchId: number, platform: 'mobile' | 'ipad', id: number) {
    return (await $http.get(`/themes/${branchId}`)).data[platform].find((theme: any) => theme.id === id)
  }

  static async updateOrCreate(platform: 'mobile' | 'ipad', payload: FormData, channel?: ThemeChannel) {
    if (platform === 'mobile' && channel) {
      payload.append('channel', channel)
      payload.append('is_mobile', channel === 'mobile_app' ? '1' : '0')
    }
    return (await $http.post(`/themes/${platform}`, payload, { headers: FormsService.MULTIPART_HEADER })).data
  }

  static async delete(platform: 'mobile' | 'ipad', id: number) {
    return (await $http.delete(`/themes/${platform}/${id}`)).data
  }

  static async activate(platform: 'mobile' | 'ipad', branch_id: number, id: number, channel?: ThemeChannel) {
    const payload: Record<string, unknown> = { branch_id }
    if (platform === 'mobile' && channel) {
      payload.channel = channel
      if (channel === 'mobile_app') {
        payload.mobile = 1
      }
    }
    return (await $http.put(`/themes/activate/${platform}/${id}`, payload)).data
  }

  static async duplicate(platform: 'mobile' | 'ipad', branch_id: number, id: number) {
    return (await $http.put(`/themes/duplicate/${platform}/${id}`, { branch_id })).data
  }

  static async updateSeparateThemeBySellingType(id: number, separateThemeBySellingType: boolean) {
    return (await $http.put(`/themes/mobile/${id}/separate-by-selling-type`, {
      separate_theme_by_selling_type: separateThemeBySellingType ? 1 : 0,
    })).data
  }
}

export default DesignAPIs
